import { FC, useState } from 'react';
import moment from 'moment';
import { Controller, useFormContext } from 'react-hook-form';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker as MuiDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// components
import DateField from 'components/common/DateField';
// interfaces
import { DatePickerControllerProps } from 'interfaces';

const DatePickerController: FC<DatePickerControllerProps> = ({
  name,
  title,
  minDate,
  maxDate,
  disabled,
  isRequired,
}) => {
  const [open, setOpen] = useState(false);
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        const onDateChange = (date: moment.Moment | string | null) => {
          onChange(date && moment(date).isValid() ? moment(date).toISOString() : '');
        };

        return (
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <MuiDatePicker
              open={open}
              disabled={disabled}
              minDate={minDate}
              maxDate={maxDate}
              inputFormat="MM/DD/YYYY"
              value={value ? value : null}
              onClose={() => setOpen(false)}
              onChange={onDateChange}
              label={isRequired ? `${title} *` : title}
              renderInput={(params) => (
                <DateField
                  {...params}
                  id={name}
                  name={name}
                  margin="dense"
                  open={open}
                  setOpen={setOpen}
                  helperText={message}
                  error={Boolean(error)}
                  onDateChange={onDateChange}
                />
              )}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
};

export default DatePickerController;
